/** Whether the browser is IE. */
const IS_IE = /Trident/.test(navigator.userAgent);

// Apply a class to the HTML element to allow for better CSS fallbacks.
if (IS_IE) {
	document.documentElement.classList.add('ie');
}

export default IS_IE;
